var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1692_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.9 20 5 20H8C8.55 20 9 19.55 9 19C9 18.45 8.55 18 8 18H5V8H19V18H16C15.45 18 15 18.45 15 19C15 19.55 15.45 20 16 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM11.65 10.35L8.86 13.14C8.54 13.46 8.76 14 9.21 14H11V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19V14H14.79C15.24 14 15.46 13.46 15.14 13.15L12.35 10.36C12.16 10.16 11.84 10.16 11.65 10.35Z",
    fill: "#0094FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1692_620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse);
export default __webpack_public_path__ + "static/media/browse.1a7e7e575c9ff2a2f44fed4497da25fd.svg";
export { ForwardRef as ReactComponent };